import React from 'react';
// template components
import BulletedList from '@nmx/template/dist/componentLibrary/components/BulletedList';
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';

import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';

export default () => (
  <SectionContainer
    id='life-insurance-learn-about-settlement-notices-section-faq'
    backgroundVariant='lightB'
    themeType='lightTheme'>
    <Row align='center'>
      <Col medium={8}>
        <Typography
          component='h2'
          nextElement='typography'
          transform='uppercase'
          align='center'>
          Learn About Settlement Plans Section
        </Typography>
        <Typography nextElement='typography'>
          Notice To Kent, Maine, Oregon AND Washington Policyowners
        </Typography>
        <Typography nextElement='typography'>
          If your life insurance policy is in danger of lapsing, please review the brochure specific to your state of residence, by clicking on one of the links listed below. These brochures detail important information about alternatives to allowing your policy to lapse.
        </Typography>
        <BulletedList
          bulletedListData={[
            {
              bulletText: <><Link
                linkUrl='https://www.northwesternmutual.com/assets/pdf/faq/ky_brochure.pdf'
                isInternalPdf
                variant='primaryDeemphasize'>
                Kentucky
              </Link></>,
            },
            {
              bulletText: <><Link
                linkUrl='https://www.northwesternmutual.com/assets/pdf/faq/me_brochure.pdf'
                isInternalPdf
                variant='primaryDeemphasize'>
                Maine
              </Link></>,
            },
            {
              bulletText: <><Link
                linkUrl='https://www.northwesternmutual.com/assets/pdf/faq/or_brochure.pdf'
                isInternalPdf
                variant='primaryDeemphasize'>
                Oregon
              </Link></>,
            },
            {
              bulletText: <><Link
                linkUrl='https://www.northwesternmutual.com/assets/pdf/faq/wa_brochure.pdf'
                isInternalPdf
                variant='primaryDeemphasize'>
                Washington
              </Link></>,
            },
          ]}
        />
      </Col>
    </Row>
  </SectionContainer>
);
